<template>
  <footer class="footer px-4">
    <div class="row align-items-center justify-content-lg-between">
      <div class="col-lg-6">
        <div class="copyright text-center text-lg-left text-muted">
          © {{ year }}
          <a
            href="https://www.agroupadvisor.com"
            class="font-weight-bold ml-1"
            target="_blank"
            >AgroUPadvisor</a
          >
          <span class="version">v{{ projectVersion }}</span>
        </div>
      </div>
      <div class="col-lg-6">
        <ul
          class="nav nav-footer justify-content-center justify-content-lg-end"
        >
          <li class="nav-item">
            <a
              href="https://www.agroupadvisor.com"
              class="nav-link"
              target="_blank"
              >AgroUPadvisor</a
            >
          </li>
          <li class="nav-item">
            <a
              href="https://agroupadvisor.com/#about"
              class="nav-link"
              target="_blank"
              >{{$t('dashboard_layout.footerAboutUs')}}</a
            >
          </li>
          <li class="nav-item">
            <a
              href="https://agroupadvisor.com/#contact"
              class="nav-link"
              target="_blank"
              >{{$t('dashboard_layout.footerContactUs')}}</a
            >
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
      projectVersion: process.env.VUE_APP_PROJECT_VERSION
    };
  },
};
</script>
<style scoped>
.version{
  padding-left: 15px;
  color: grey;
}
</style>
